// extracted by mini-css-extract-plugin
export default {"notes-list-root":"styles_notes-list-root__7fh7B"};